<template>
    <div class="col-md-12">
        <p class="hint">Store Hours</p>
        <table class="table table-sm table-striped">
            <tbody>
                <tr>
                    <th>Sunday</th>
                    <td>{{ formatHours(hours.sunday) }}</td>
                </tr>
                <tr>
                    <th>Monday</th>
                    <td>{{ formatHours(hours.monday) }}</td>
                </tr>
                <tr>
                    <th>Tuesday</th>
                    <td>{{ formatHours(hours.tuesday) }}</td>
                </tr>
                <tr>
                    <th>Wednesday</th>
                    <td>{{ formatHours(hours.wednesday) }}</td>
                </tr>
                <tr>
                    <th>Thursday</th>
                    <td>{{ formatHours(hours.thursday) }}</td>
                </tr>
                <tr>
                    <th>Friday</th>
                    <td>{{ formatHours(hours.friday) }}</td>
                </tr>
                <tr>
                    <th>Saturday</th>
                    <td>{{ formatHours(hours.saturday) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import { DateTime } from 'luxon'
export default {
    props: {
        hours: {
            type: [Object, Boolean],
            required: true
        }
    },
    methods: {
        formatHours(hours) {
            return hours
                ? `${DateTime.fromMillis(hours.open).toLocaleString(DateTime.TIME_SIMPLE)} - ${DateTime.fromMillis(hours.close).toLocaleString(
                      DateTime.TIME_SIMPLE
                  )}`
                : 'N/A'
        }
    }
}
</script>
